/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AuthedHomeRouteImport } from './routes/_authed/home'
import { Route as AuthedLibraryRouteImport } from './routes/_authed/library'
import { Route as AuthedOutboxRouteImport } from './routes/_authed/outbox'
import { Route as AuthedPeopleRouteImport } from './routes/_authed/people'
import { Route as AuthedYouRouteImport } from './routes/_authed/you'
import { Route as AuthedDocumentsIndexRouteImport } from './routes/_authed/documents.index'
import { Route as AuthedDocumentsDocumentIdRouteImport } from './routes/_authed/documents.$documentId'
import { Route as AuthedDocumentsNewRouteImport } from './routes/_authed/documents.new'
import { Route as AuthedPeoplePersonIdRouteImport } from './routes/_authed/people.$personId'
import { Route as AuthedThingsIndexRouteImport } from './routes/_authed/things.index'
import { Route as AuthedThingsThingIdRouteImport } from './routes/_authed/things.$thingId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedHomeRoute = AuthedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLibraryRoute = AuthedLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOutboxRoute = AuthedOutboxRouteImport.update({
  id: '/outbox',
  path: '/outbox',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPeopleRoute = AuthedPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedYouRoute = AuthedYouRouteImport.update({
  id: '/you',
  path: '/you',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDocumentsIndexRoute = AuthedDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDocumentsDocumentIdRoute =
  AuthedDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDocumentsNewRoute = AuthedDocumentsNewRouteImport.update({
  id: '/documents/new',
  path: '/documents/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPeoplePersonIdRoute = AuthedPeoplePersonIdRouteImport.update({
  id: '/$personId',
  path: '/$personId',
  getParentRoute: () => AuthedPeopleRoute,
} as any)
const AuthedThingsIndexRoute = AuthedThingsIndexRouteImport.update({
  id: '/things/',
  path: '/things/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedThingsThingIdRoute = AuthedThingsThingIdRouteImport.update({
  id: '/things/$thingId',
  path: '/things/$thingId',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/home': typeof AuthedHomeRoute
  '/library': typeof AuthedLibraryRoute
  '/outbox': typeof AuthedOutboxRoute
  '/people': typeof AuthedPeopleRouteWithChildren
  '/you': typeof AuthedYouRoute
  '/documents/$documentId': typeof AuthedDocumentsDocumentIdRoute
  '/documents/new': typeof AuthedDocumentsNewRoute
  '/people/$personId': typeof AuthedPeoplePersonIdRoute
  '/things/$thingId': typeof AuthedThingsThingIdRoute
  '/documents/': typeof AuthedDocumentsIndexRoute
  '/things/': typeof AuthedThingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/home': typeof AuthedHomeRoute
  '/library': typeof AuthedLibraryRoute
  '/outbox': typeof AuthedOutboxRoute
  '/people': typeof AuthedPeopleRouteWithChildren
  '/you': typeof AuthedYouRoute
  '/documents/$documentId': typeof AuthedDocumentsDocumentIdRoute
  '/documents/new': typeof AuthedDocumentsNewRoute
  '/people/$personId': typeof AuthedPeoplePersonIdRoute
  '/things/$thingId': typeof AuthedThingsThingIdRoute
  '/documents': typeof AuthedDocumentsIndexRoute
  '/things': typeof AuthedThingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_authed/home': typeof AuthedHomeRoute
  '/_authed/library': typeof AuthedLibraryRoute
  '/_authed/outbox': typeof AuthedOutboxRoute
  '/_authed/people': typeof AuthedPeopleRouteWithChildren
  '/_authed/you': typeof AuthedYouRoute
  '/_authed/documents/$documentId': typeof AuthedDocumentsDocumentIdRoute
  '/_authed/documents/new': typeof AuthedDocumentsNewRoute
  '/_authed/people/$personId': typeof AuthedPeoplePersonIdRoute
  '/_authed/things/$thingId': typeof AuthedThingsThingIdRoute
  '/_authed/documents/': typeof AuthedDocumentsIndexRoute
  '/_authed/things/': typeof AuthedThingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/home'
    | '/library'
    | '/outbox'
    | '/people'
    | '/you'
    | '/documents/$documentId'
    | '/documents/new'
    | '/people/$personId'
    | '/things/$thingId'
    | '/documents/'
    | '/things/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/signup'
    | '/home'
    | '/library'
    | '/outbox'
    | '/people'
    | '/you'
    | '/documents/$documentId'
    | '/documents/new'
    | '/people/$personId'
    | '/things/$thingId'
    | '/documents'
    | '/things'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/signup'
    | '/_authed/home'
    | '/_authed/library'
    | '/_authed/outbox'
    | '/_authed/people'
    | '/_authed/you'
    | '/_authed/documents/$documentId'
    | '/_authed/documents/new'
    | '/_authed/people/$personId'
    | '/_authed/things/$thingId'
    | '/_authed/documents/'
    | '/_authed/things/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/home': {
      id: '/_authed/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthedHomeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/library': {
      id: '/_authed/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof AuthedLibraryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/outbox': {
      id: '/_authed/outbox'
      path: '/outbox'
      fullPath: '/outbox'
      preLoaderRoute: typeof AuthedOutboxRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/people': {
      id: '/_authed/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof AuthedPeopleRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/you': {
      id: '/_authed/you'
      path: '/you'
      fullPath: '/you'
      preLoaderRoute: typeof AuthedYouRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/documents/': {
      id: '/_authed/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthedDocumentsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/documents/$documentId': {
      id: '/_authed/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/documents/$documentId'
      preLoaderRoute: typeof AuthedDocumentsDocumentIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/documents/new': {
      id: '/_authed/documents/new'
      path: '/documents/new'
      fullPath: '/documents/new'
      preLoaderRoute: typeof AuthedDocumentsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/people/$personId': {
      id: '/_authed/people/$personId'
      path: '/$personId'
      fullPath: '/people/$personId'
      preLoaderRoute: typeof AuthedPeoplePersonIdRouteImport
      parentRoute: typeof AuthedPeopleRoute
    }
    '/_authed/things/': {
      id: '/_authed/things/'
      path: '/things'
      fullPath: '/things/'
      preLoaderRoute: typeof AuthedThingsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/things/$thingId': {
      id: '/_authed/things/$thingId'
      path: '/things/$thingId'
      fullPath: '/things/$thingId'
      preLoaderRoute: typeof AuthedThingsThingIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedPeopleRouteChildren {
  AuthedPeoplePersonIdRoute: typeof AuthedPeoplePersonIdRoute
}

const AuthedPeopleRouteChildren: AuthedPeopleRouteChildren = {
  AuthedPeoplePersonIdRoute: AuthedPeoplePersonIdRoute,
}

const AuthedPeopleRouteWithChildren = AuthedPeopleRoute._addFileChildren(
  AuthedPeopleRouteChildren,
)

interface AuthedRouteChildren {
  AuthedHomeRoute: typeof AuthedHomeRoute
  AuthedLibraryRoute: typeof AuthedLibraryRoute
  AuthedOutboxRoute: typeof AuthedOutboxRoute
  AuthedPeopleRoute: typeof AuthedPeopleRouteWithChildren
  AuthedYouRoute: typeof AuthedYouRoute
  AuthedDocumentsDocumentIdRoute: typeof AuthedDocumentsDocumentIdRoute
  AuthedDocumentsNewRoute: typeof AuthedDocumentsNewRoute
  AuthedThingsThingIdRoute: typeof AuthedThingsThingIdRoute
  AuthedDocumentsIndexRoute: typeof AuthedDocumentsIndexRoute
  AuthedThingsIndexRoute: typeof AuthedThingsIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedHomeRoute: AuthedHomeRoute,
  AuthedLibraryRoute: AuthedLibraryRoute,
  AuthedOutboxRoute: AuthedOutboxRoute,
  AuthedPeopleRoute: AuthedPeopleRouteWithChildren,
  AuthedYouRoute: AuthedYouRoute,
  AuthedDocumentsDocumentIdRoute: AuthedDocumentsDocumentIdRoute,
  AuthedDocumentsNewRoute: AuthedDocumentsNewRoute,
  AuthedThingsThingIdRoute: AuthedThingsThingIdRoute,
  AuthedDocumentsIndexRoute: AuthedDocumentsIndexRoute,
  AuthedThingsIndexRoute: AuthedThingsIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
